
import filterTaxRegimeJson from "../../../../dataComponets/invoice/filterregimen.json";
import filterUsoCFDIJson from "../../../../dataComponets/invoice/filtercfdi.json";

export type FilterTaxRegimen = { value: number; label: string; person_type: number };
export type FilterUsoCFDI = { value: string; stf?: number[] };

export const filterTaxRegime = filterTaxRegimeJson as FilterTaxRegimen[];
export const filterUsoCFDI = filterUsoCFDIJson as FilterUsoCFDI[];
